// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".six-icons--T0Ci1 .icon-area--sjwGf .material-symbols-outlined{font-size:30px}.six-icons--T0Ci1 .remove-bottom-margin--uJP06 p{margin-bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"six-icons": "six-icons--T0Ci1",
	"icon-area": "icon-area--sjwGf",
	"remove-bottom-margin": "remove-bottom-margin--uJP06"
};
export default ___CSS_LOADER_EXPORT___;
